module.exports = __webpack_public_path__ + "static/img/logo2.a52300a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo2.svg
// module id = N/lZ
// module chunks = 1